import { takeOffAuditMap } from '@/api';
import { post } from '@/common/request';
import { City } from './place';

export interface SearchParams extends City {
  tntPlaceName?: string;
  tntPlaceId?: number;
  tntSpotName?:	string;
  tntSpotId?:	number;
  tntPlaceCategoryIds?:	number[]
  type?: string;
  status?: string;
}


export interface TakeOffAuditIndfo {
  tntSpotName?:	string;
  tntPlaceName?: string;
  categoryName?: string;
  type?: number;
  submitDateFormat?: string;
  examineDateFormat?:	string;
  statusName?: string;
  typeName?: string;
}

interface Respone {
  pageSize?: number;
  pageNo?: number;
  objectList?: TakeOffAuditIndfo[]
}

interface Reason {
  offlineReason?: string
}

export interface OnLineReason extends Reason {
  lastExamineOfflineTime?: string;
}

export interface OfflineReason extends Reason {
  rejectReason?: string;
}

class TakeOffAuditStore {
  getList(page, size, searchParams: SearchParams): Promise<Respone> {
    return post(takeOffAuditMap.get('list'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  pass(tntExamineOrderId: number, propertyIds: number[], examineType: string, propertyValueList?: any[]) {
    return post(takeOffAuditMap.get('pass'), { tntExamineOrderId, propertyIds, examineType, propertyValueList }, { proxyApi: '/resserv', needHint: true });
  }

  reject(tntExamineOrderId: number, rejectReason: string) {
    return post(takeOffAuditMap.get('reject'), { tntExamineOrderId, rejectReason }, { proxyApi: '/resserv', needHint: true });
  }

  getEditList(id: number): Promise<any> {
    return post(takeOffAuditMap.get('edit'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  onlineDetail(id: number): Promise<OnLineReason> {
    return post(takeOffAuditMap.get('onlineDetail'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  offlineDetail(id: number): Promise<OfflineReason> {
    return post(takeOffAuditMap.get('offlineDetail'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  batchOnline(tenantSpotIdList: number[]): Promise<boolean> {
    return post(takeOffAuditMap.get('batchOnline'), { tenantSpotIdList }, { proxyApi: '/resserv', needHint: true });
  }

  batchOffline(tenantSpotIdList: number[]): Promise<boolean> {
    return post(takeOffAuditMap.get('batchOffline'), { tenantSpotIdList }, { proxyApi: '/resserv', needHint: true });
  }

  online(tenantSpotId: number): Promise<boolean> {
    return post(takeOffAuditMap.get('online'), { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }

  offline(tenantSpotId: number): Promise<boolean> {
    return post(takeOffAuditMap.get('offline'), { tenantSpotId }, { proxyApi: '/resserv', needHint: true });
  }
}

export default new TakeOffAuditStore();
